// extracted by mini-css-extract-plugin
export default {"notificationTitle":"NotificationScreen_notificationTitle__0v9Sf","container":"NotificationScreen_container__oMzKS"};